(() => {
  const settings = window.subscriptionSettings;
  if (!settings?.collectionHandle) return;

  const modal = document.getElementById('subscription-modal');
  if (!modal) return;

  let pendingVariantId = null;
  let bypassNext = false;
  let collectionIdSet = null; // synchron verfügbar, sobald geladen

  const collectionIds = fetch(`/collections/${settings.collectionHandle}/products.json?limit=250`)
    .then((r) => r.json())
    .then((data) => new Set(data.products.map((p) => String(p.id))))
    .catch(() => new Set())
    .then((ids) => {
      collectionIdSet = ids;
      return ids;
    });

  // Form erneut absenden, außerhalb des laufenden submit-Dispatch.
  // requestSubmit() ist ein No-op, solange das Form noch Submit-Events feuert,
  // deshalb per setTimeout in den nächsten Task verschieben.
  const resubmit = (form, submitter) => {
    setTimeout(() => {
      if (!form.isConnected) return;
      bypassNext = true;
      try {
        if (submitter && submitter.isConnected && submitter.form === form) {
          form.requestSubmit(submitter);
        } else {
          form.requestSubmit();
        }
      } finally {
        // Falls kein submit-Event ausgelöst wurde, darf das Flag nicht hängen bleiben
        bypassNext = false;
      }
    }, 0);
  };

  // Intercept ATB submits, nur für Produkte aus der Abo-Collection
  document.addEventListener('submit', (event) => {
    if (bypassNext) { bypassNext = false; return; }

    const form = event.target;
    if (form.tagName !== 'FORM') return;

    const productForm = form.closest('product-form');
    const productId = productForm?.dataset.productId;
    if (!productId) return;

    // Collection bereits geladen und Produkt nicht drin: gar nicht abfangen
    if (collectionIdSet && !collectionIdSet.has(productId)) return;

    event.stopImmediatePropagation();
    event.preventDefault();

    const submitter = event.submitter;

    collectionIds.then(async (ids) => {
      if (!ids.has(productId)) {
        resubmit(form, submitter);
        return;
      }

      try {
        const cart = await fetch(`${Shopify.routes.root}cart.js`).then((r) => r.json());
        const hasSubscription = cart.items.some(
          (item) => item.properties?._bundled_subscription === 'true'
        );
        if (hasSubscription) {
          resubmit(form, submitter);
          return;
        }
      } catch (_) {}

      const variantInput = form.querySelector('input[name="id"]');
      if (!variantInput) return;
      pendingVariantId = variantInput.value;
      modal.show();
    });
  }, true);

  // CTA: add lounger + subscription to cart
  modal.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-subscription-cta]');
    if (!btn || !pendingVariantId) return;

    btn.disabled = true;
    try {
      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      }));

      const cartState = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      const alreadyHasSubscription = cartState.items.some(
        (item) => item.properties?._bundled_subscription === 'true'
      );

      const items = [{ id: parseInt(pendingVariantId, 10), quantity: 1 }];
      if (!alreadyHasSubscription) {
        items.push({
          id: parseInt(btn.dataset.variantId, 10),
          quantity: 1,
          properties: {
            _bundled_subscription: 'true',
            _subscription_bundle_key: pendingVariantId,
          },
        });
      }
      const body = { items };
      if (sectionsToBundle.length) body.sections = sectionsToBundle.join(',');

      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body),
      });
      if (!response.ok) {
        const errBody = await response.json().catch(() => ({}));
        console.error('[subscription-modal] cart/add.js error:', errBody);
        throw new Error('Cart add failed');
      }

      const addJson = await response.json();
      const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cart.sections = addJson.sections;

      modal.hide();
      pendingVariantId = null;
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart }
      }));
    } catch (err) {
      console.error('[subscription-modal]', err);
    } finally {
      btn.disabled = false;
    }
  });

  // Auto-remove subscription when no collection product remains in cart
  document.documentElement.addEventListener('cart:change', async (event) => {
    if (event.detail?.baseEvent === 'subscription:auto-remove') return;

    try {
      const [cart, ids] = await Promise.all([
        fetch(`${Shopify.routes.root}cart.js`).then((r) => r.json()),
        collectionIds,
      ]);

      const hasCollectionProduct = cart.items.some(
        (item) =>
          ids.has(String(item.product_id)) &&
          item.properties?._bundled_subscription !== 'true'
      );
      if (hasCollectionProduct) return;

      const updates = {};
      for (const item of cart.items) {
        if (item.properties?._bundled_subscription === 'true') updates[item.key] = 0;
      }

      if (!Object.keys(updates).length) return;

      await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });

      if (window.location.pathname.endsWith('/cart')) {
        window.location.reload();
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    } catch (err) {
      console.error('[subscription-modal] auto-remove', err);
    }
  });
})();
